// Function to show error message
function showErrorMessage(message, isToast = false) {
    // Remove any existing messages
    $('.quantity-error-message, .cart-message--error').remove();

    if (message) {
        if (isToast) {
            const messageDiv = $(`
                <div class="cart-message cart-message--error">
                    ${message}
                </div>
            `);
            messageDiv.css({
                position: "fixed",
                top: "20px",
                right: "20px",
                padding: "15px 20px",
                borderRadius: "5px",
                zIndex: 999999999,
                fontWeight: "bold",
                backgroundColor: "#f44336",
                color: "white",
                boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                transform: "translateX(100%)",
                transition: "transform 0.3s ease",
                maxWidth: "300px",
                wordWrap: "break-word"
            });

            $("body").append(messageDiv);
            setTimeout(() => messageDiv.css("transform", "translateX(0)"), 10);
            setTimeout(() => {
                messageDiv.css("transform", "translateX(100%)");
                setTimeout(() => messageDiv.remove(), 300);
            }, 4000);
        } else {
            const errorDiv = $(`<div class="quantity-error-message" style="color: #d32f2f; margin: 5px 0; font-size: 12px;">${message}</div>`);
            $("#hulkapp_reorder_master").append(errorDiv);
        }
    }
}

// Function to validate all quantity inputs
function validateQuantities() {
    const quantityInputs = $("#hulkapp_reorder_master input.hulk_qty_input[type='number']");

    // If no inputs found, the element might not be loaded yet
    if (quantityInputs.length === 0) {
        $("#add_to_card_button, #reorder_button").prop('disabled', true).addClass('button-disabled');
        return false;
    }

    let allValid = true;
    let hasValue = false;
    let hasInvalidInput = false;

    // First, check all inputs
    quantityInputs.each(function () {
        const input = $(this);
        const quantity = parseInt(input.val()) || 0;

        if (quantity > 0) {
            hasValue = true;

            if (quantity < 10 || quantity % 10 !== 0) {
                allValid = false;
                hasInvalidInput = true;
                input.css("border", "2px solid #d32f2f");
            } else {
                input.css("border", "1px solid #d3d3d2");
            }
        } else {
            input.css("border", "1px solid #d3d3d2");
        }
    });

    // Update button states and show/hide messages
    const buttons = $("#add_to_card_button, #reorder_button");

    if (allValid && hasValue) {
        // All inputs are valid - enable buttons and clear any error messages
        buttons.prop('disabled', false).removeClass('button-disabled');
        showErrorMessage('');
    } else {
        // Some inputs are invalid - disable buttons and show appropriate error
        buttons.prop('disabled', true).addClass('button-disabled');
        showErrorMessage('Invalid quantity: 5. Must be 10, 20, 30, etc. (minimum 10)', true);
    }

    return allValid && hasValue;
}

// Function to initialize the quantity validation
function initQuantityValidation() {
    const targetNode = document.getElementById('hulkapp_reorder_master');

    if (targetNode) {
        // Element exists, set up validation
        setupValidation();
    } else {
        // Use MutationObserver to detect when the element is added
        const observer = new MutationObserver(function (mutations, obs) {
            if (document.getElementById('hulkapp_reorder_master')) {
                setupValidation();
                obs.disconnect(); // Stop observing once we've found the element
            }
        });

        // Start observing the document with the configured parameters
        observer.observe(document.body, { childList: true, subtree: true });
    }
}

// Set up event listeners and initial validation
function setupValidation() {
    // Initial validation
    validateQuantities();

    // Handle input changes with debounce for better performance
    let typingTimer;
    const doneTypingInterval = 300; // 300ms delay after user stops typing

    // Function to validate quantity input
    function validateQuantityInput($input) {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function () {
            validateQuantities();
        }, doneTypingInterval);
    }

    // Handle manual input changes
    $(document).on('input', "#hulkapp_reorder_master input.hulk_qty_input[type='number']", function () {
        validateQuantityInput($(this));
    });

    // Handle blur event
    $(document).on('blur', "#hulkapp_reorder_master input.hulk_qty_input[type='number']", function () {
        validateQuantityInput($(this));
    });

    // Override the global quantityfunctionBtn to trigger validation
    if (typeof window.quantityfunctionBtn === 'function') {
        const originalQuantityFunctionBtn = window.quantityfunctionBtn;
        window.quantityfunctionBtn = function (type, index) {
            // Call the original function
            originalQuantityFunctionBtn(type, index);

            // Get the input element
            const $input = $(`#quantity_${index}`);
            if ($input.length) {
                // Trigger immediate validation after the value changes
                setTimeout(() => {
                    validateQuantities();
                }, 10);
            }
        };
    }

    // Also handle direct button clicks in case the above override doesn't work
    $(document).on('click', '.hulk_prod_qty button.hulk_qty_input', function () {
        // Small delay to allow the value to update
        setTimeout(() => {
            validateQuantities();
        }, 10);
    });

    // Handle delete button clicks
    $(document).on('click', '.hulk_deletebtn', function (e) {
        // Small delay to allow the product to be removed from the DOM
        setTimeout(() => {
            validateQuantities();
        }, 100);
    });

    // Override the global delete function if it exists
    if (typeof window.hulk_deletebtn === 'function') {
        const originalDeleteBtn = window.hulk_deletebtn;
        window.hulk_deletebtn = function (index) {
            // Call the original function
            originalDeleteBtn(index);

            // Update validation after deletion
            setTimeout(() => {
                validateQuantities();
            }, 100);
        };
    }

    // Handle reorder button click
    $(document).on("click", ".hulk_reorder_button", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Get the product ID from the onclick attribute
        const $button = $(this);
        const onclickAttr = $button.attr('onclick');
        const productIdMatch = onclickAttr && onclickAttr.match(/Hulkappreorder\((\d+)\)/);

        if (productIdMatch && productIdMatch[1]) {
            const productId = productIdMatch[1];
            // Find the quantity input for this product
            const $quantityInput = $(`input.hulk_qty_input[data-product-id="${productId}"][type="number"]`);

            if ($quantityInput.length) {
                const quantity = parseInt($quantityInput.val()) || 0;

                // Validate quantity
                if (quantity === 0) {
                    showErrorMessage('Invalid quantity: 5. Must be 10, 20, 30, etc. (minimum 10)', true);
                    $quantityInput.focus().css("border", "2px solid #d32f2f");
                    return false;
                } else if (quantity < 10 || quantity % 10 !== 0) {
                    showErrorMessage('Invalid quantity: 5. Must be 10, 20, 30, etc. (minimum 10)', true);
                    $quantityInput.focus().css("border", "2px solid #d32f2f");
                    return false;
                }
            }

            // Store the current scroll position
            const scrollPosition = window.scrollY;

            // Set up a mutation observer to detect when #hulkapp_reorder_master is re-added
            const observer = new MutationObserver(function (mutations) {
                if (document.getElementById('hulkapp_reorder_master')) {
                    // Re-initialize validation for the new content
                    setupValidation();

                    // Restore scroll position
                    window.scrollTo(0, scrollPosition);

                    // Disconnect the observer after we're done
                    observer.disconnect();
                }
            });

            // Start observing the document body for changes
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            // Proceed with the reorder (this will trigger the re-render)
            window.Hulkappreorder(productId);

            // Clear any existing #hulkapp_reorder_master
            $('#hulkapp_reorder_master').remove();
        }

        return false;
    });

    // Validate on add to cart button click
    $(document).on("click", "#add_to_card_button", function (e) {
        clearTimeout(typingTimer);
        if (!validateQuantities()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        }
    });
}

// Initialize when the document is ready
$(document).ready(function () {
    if (typeof jQuery.fn.slickV2 === 'function') {
        if (jQuery(".grid--blog").length) {
            jQuery(".grid--blog").slickV2({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true,
                infinite: true,
                responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        },
                    ]
            });
        }

        if (jQuery(".three-column-block--wrapper").length) {
            jQuery(".three-column-block--wrapper").slickV2({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                    infinite: true,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        },
                    ],
                    
            });
        }
    }
});

